














import { CodebookModel, CodebookTypeEnum, UnitOfMeasureModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { unitsOfMeasureStore } from '@/libs/units-of-measure/+state/store';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class UnitOfMeasureSelect extends Vue {

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() type!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;

    get items(): UnitOfMeasureModel[] {
        const items = unitsOfMeasureStore.useGetter(CrudGetter.Data) as UnitOfMeasureModel[];
        items.forEach((e: UnitOfMeasureModel) => {
            e.name = this.$i18n.t("codebooks.".concat(e.nameIdentifier!)).toString();
            e.shortName = this.$i18n.t("codebooks.".concat(e.shortNameIdentifier!)).toString();
        });
        if (this.innerValue == null && items.find((x: UnitOfMeasureModel) => x.defaultValue)) {
            this.$emit("input", items.find((x: UnitOfMeasureModel) => x.defaultValue)?.id);
        }
        return items;
    }

    @Watch("innerValue")
    innerValueChanged (v: string) {
        this.$emit("change", this.items?.find(x => x.id == v));
    }

}
